import { useContext } from "react";
import AuthContext from "context/AuthContext";
import BoxFilters from "./waste/BoxFilters"
import BoxFiltersBridge from "./bridge/BoxFiltersBridge"

const BoxFiltersManager = ({ items, setItemsShown, showFilter, filters, filterByDate, setButtonsTB, buttonsTB }) => {
    const { panel } = useContext(AuthContext);
    switch (panel.panel_type) {
        case 'b':
            return <BoxFiltersBridge items={items} setItemsShown={setItemsShown} showFilter={showFilter} filters={filters} filterByDate={filterByDate} setButtonsTB={setButtonsTB} buttonsTB={buttonsTB} />
        default:
            return <BoxFilters items={items} setItemsShown={setItemsShown} showFilter={showFilter} filters={filters} filterByDate={filterByDate} setButtonsTB={setButtonsTB} buttonsTB={buttonsTB} />
    }
}

export default BoxFiltersManager